import { configureStore } from '@reduxjs/toolkit'
import {
    configurationReducer,
    dtReducer,
    metaReducer,
    slownikFormSelectedReducer,
    statusySlice,
    userReducer,
    wizardSlice,
} from './'

const store = configureStore({
    reducer: {
        meta: metaReducer,
        configuration: configurationReducer,
        user: userReducer,
        dt: dtReducer,
        slownikFormSelected: slownikFormSelectedReducer,
        wizard: wizardSlice,
        statusy: statusySlice,
    },
})

export default store
